module.exports = __webpack_public_path__ + "img/sms-convo.96ad5419.png";